import React, {Component} from 'react';
import {Problem} from './Problem';
import {getLongestStreak, updateLongestStreak} from '../services/UserStatsService';
import {LearnBox} from "./LearnBox";
import {pushTracking} from "../services/TrackingService";
import {PointsProgress} from "./PointsProgress";
import {LearnPage} from "./LearnPage";
import {LearnSection} from "./LearnSection";
import {getSubject} from "../services/SubjectService";
import {GameBox} from "./GameBox";

export class Streak extends Component {
    static displayName = Streak.name;

    constructor(props) {
        super(props);
        var pathParts = window.location.pathname.split("/");
        var subjectKey = pathParts[2];
        var themeKey = pathParts[3];
        var longestStreak = getLongestStreak(subjectKey);
        this.state = {
            subjectKey: subjectKey,
            themeKey: themeKey,
            streakLength: 0,
            continueStreak: true,
            longestStreak: longestStreak,
            streakRecord: false,
            loading: true
        };
        this.tryAgain = this.tryAgain.bind(this);
    }

    componentDidMount() {
        this.fetchSubject();
    }

    onResult = (event) => {
        if (event.correct) {
            const streakLength = this.state.streakLength + 1;
            const streakRecord = streakLength > this.state.longestStreak;
            const longestStreak = updateLongestStreak(this.state.subjectKey, streakLength);
            this.setState({
                streakLength: streakLength,
                longestStreak: longestStreak,
                showContinueStreak: true,
                streakRecord: streakRecord
            });
            pushTracking("ProblemCorrect", {ProblemId: event.problem.id, TemplateId: event.problem.templateId});
        } else {
            this.setState({continueStreak: false});
            pushTracking("ProblemIncorrect", {ProblemId: event.problem.id, TemplateId: event.problem.templateId})
        }
    }

    onNewProblem = (event) => {
        this.setState({showContinueStreak: false});
    }

    tryAgain = () => {
        this.setState({streakLength: 0, continueStreak: true, streakRecord: false});
    }

    render() {
        if (this.state.loading) {
            return <div>Indlæser opgave...</div>;
        }

        let problem = this.state.continueStreak ?
            (
                <Problem subjectKey={this.state.subjectKey}
                         themeKey={this.state.themeKey}
                         onResult={this.onResult}
                         onNewProblem={this.onNewProblem}
                         mode="streak"/>
            ) :
            (
                <div>
                    <p>Forkert! Din stime er færdig!</p>
                    <input type="button" value="Start forfra" className="btn btn-info" onClick={this.tryAgain}/>
                </div>
            );
        let record = this.state.streakRecord ? <h6>Tillykke! Ny personlig stime-rekord!</h6> : null;

        return (
            <LearnPage title="Opgave-stime" backUrl={"/subject/" + this.state.subjectKey}
                       backTitle={this.state.subject.displayName}>
                <LearnSection>
                    <GameBox currentGameText="Din stime" currentGameNumber={this.state.streakLength}
                             subjectKey={this.state.subjectKey}>
                        {problem}
                        {record}
                        {this.state.showContinueStreak ? <p>Tryk enter eller OK for at fortsætte stimen.</p> : null}
                    </GameBox>
                    <LearnBox title="Stime">
                        {record}
                        <p>Din stime: {this.state.streakLength}</p>
                        <p>Din bedste stime: {this.state.longestStreak}</p>
                    </LearnBox>
                    <LearnBox title="Om Opgave-stime">
                        <p>Løs opgaver af stigende sværhedsgrad og opbyg en sejrsstime.</p>
                        <p>Der er intet ur, så tag dig god tid. Én forkert opgave og spillet er ovre!</p>
                        <p><em>Stime</em> betyder <em>stor flok</em>. Udfordr dig selv og se hvor stor en flok
                            opgaver du kan løse i træk.</p>
                    </LearnBox>
                    <LearnBox title="Dagligt mål">
                        <PointsProgress subjectKey={this.state.subjectKey}/>
                    </LearnBox>
                </LearnSection>
            </LearnPage>
        );
    }

    fetchSubject() {
        getSubject(this.state.subjectKey).then(subject => {
            this.setState({subject: subject, loading: false});
        });
    }
}
